import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import PaymentHistory from 'types/payment_history'

const resource = 'payment_histories'

export const requests = {
  fetchIndex: async (
    tartgetDay: string | null,
    page: number,
    limit: number,
  ) => {
    return await axiosForGigbaseBiz.get<DataResponse<PaymentHistory[]>>(
      resource,
      {
        params: {
          page,
          limit,
          target_day: tartgetDay,
        },
      },
    )
  },
}
